export const en = {
  language: "EN",
  search: "Search",
  day: "day",
  find: "Find",
  back: "Back",
  next: "Next",
  finish: "Finish",
  selected: "Selected",
  selecteds: "Selected",
  value: "Value",
  confirm: "Confirm",
  cancel: "Cancel",
  update: "Update",
  editto: "Edit",
  correct: "Correct",
  correctErrors: "Correct Errors",
  create: "Create",
  register: "Register",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  reload: "Reload",
  message: "Message",
  save: "Save",
  export: "Export",
  other: "Other options",
  send: "Send",
  or: "or",
  name: "Name",
  enter: "Enter",
  start: "Start",
  begin: "Start",
  gotIt: "Got It",
  follow: "Follow",
  following: "Following",
  unfollow: "Unfollow",
  continue: "Continue",
  share: "Share",
  include: "Include",
  yes: "Yes",
  no: "No",
  cpf: "CPF",
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  seeMore: "See more",
  deleteUser: "Delete user",
  warningDeleteUser:
    "This contributor, his projects and composition databases will be permanently deleted, removing all access to the platform. This action cannot be undone.",
  trialRegister: {
    enter: "Enter",
    freeTrial: "Free Trial",
    requestTrial: "REQUEST YOUR TRIAL PERIOD",
    meetRubk01:
      "With Rubk, you will have access to the first budget solution defined with BIM modeling in Brazil.",
    meetRubk02:
      "In a simple and intuitive way, you will reduce budget-related errors and improve your company's cost control.",
    meetRubk03:
      "From the initial phase, Rubk guides with the help of indicators that will serve as support for decision-making throughout the project.",
    meetRubk04:
      "What are you waiting for? Fill out the form and transform your routine with Rubk.",
    freeTrialDays: "Free trial for 30 days!",
    privacyPolicy: "Privacy Policy",
    privacyPolicyMessage:
      "I have read and agree to Senior's %s, which may use the information provided by me here to contact me, via email, phone or whatsapp, for actions of a commercial nature. I can revoke my consent at any time by sending an email to lgpd@senior.com.br.*",
    checkYourEmail: "Check your email",
    almostThere01: "Almost there! We sent an email to:",
    almostThere02:
      "Click on the link sent to your email to complete your registration.",
    almostThere03: "If you can't find it, try checking your spam folder.",
    almostThere04: "Didn't find any email?",
    resendEmail: "Resend email",
    subscribeNow: "Subscribe now",
    subscribeNow02: "Subscribe now",
    trialEexpiresIn:
      "Your trial version expires in %s. Subscribe now and enjoy everything that Rubk has to offer.",
    welcome: {
      engineeringCosts: "ENGINEERING COSTS UP TO 90% MORE AGILE AND ACCURATE",
      meetRubk:
        "Meet Rubk, the first budget solution aligned with BIM modeling in Brazil!",
      welcomeToRubk: "Welcome to Rubk!",
      continue: "Continue",
    },
    whatToLearn: {
      linkText01: "Importing a spreadsheet into the Cost Plan",
      linkText02: "Importing BIM models",
      linkText03: "Creating quantitative rules",
      linkText04: "Working with composition banks",
      linkText05: "Check out our full documentation",
      notDisplayMessage: "Do not display this message again",
      whatLearn: "What do you want to learn?",
    },
    subcribeCard: {
      cadTitle: "We're almost there!",
      cardTxt01:
        "With the best BIM-driven platform in Brazil, you are raising the level on precision.",
      cardTxt02: "After confirming your subscription",
      cardTxt03:
        ", our sales team will contact you as soon as possible so you can enjoy the best experience Rubk has to offer!",
      textBack: "Maybe later",
      textButton: "Confirm Enrollment",
      snackText01: "Registration successfully confirmed.",
      snackText02: "Our team will contact you shortly.",
    },
  },
  trialExpired: {
    title: "Your trial period has ended!",
    message:
      "Subscribe to *Rubk* and continue to bring agility, technology and consistency to all your projects.",
  },
  trialMessage: {
    title: "Account upgrade",
    spaceMessage:
      "Oops! The *trial* version allows you to use up to *250 MB* of space to import templates.",
    spaceMessage2:
      "Upgrade your account and import an *unlimited* number of templates.",
    resourceMessage: "This feature is not available on the *trial* plan.",
    resourceMessage2:
      "Upgrade and make the most of the features *Rubk* has to offer.",
    rememberLater: "Remind me later",
    functionalityNotAvailable: "Functionality not available in Trial access!",
  },
  login: {
    userCreated: "User created successfully",
    isntEmail:
      "The value entered is not a valid email. Please enter a valid email address.",
    accountExistsDifferent: "Account exists with different credential",
    emailAlreadyInUse: "Email already in use",
    passwordLength: "Password must have at least 6 characters",
    wrongPassword: "E-mail and password are not valid",
    reset: "Reset",
    isntCpf: "",
    resetPassword: "Reset password",
    resetPasswordSuccess: "Password changed successfully!",
    resendEmail: "Please, go to login and request your verification again.",
    loginError: "Unable to authenticate with provided credentials",
    userDisabled: "User disabled.",
    emailError: "Unable to verify your e-mail.",
    newSessionError: "A new session has been started for this user.",
    invalidAccessError: "User does not have access permission.",
    emailSucess: "Your e-mail was successfully verified!",
    emailSucessSubmessage: "We are all ready to start now.",
    emailSent: "Recovery password e-mail sent",
    emailNotSent: "E-mail not found",
    password: "Password",
    newPassword: "New Password",
    forgotPassword: "Forgot your password?",
    forgotPasswordMessage: "Fill in with your e-mail address",
    enterRubk: "Enter Rubk",
    createAccount: "Create account",
    createAccountCaption: "Create Rubk account",
    createAccountMessage:
      "By continuing, you agree to our Terms and Conditions and our Privacy Policy.",
    socialAccountLoginMessage: "Fill the fields bellow.",
    /* googleLogin: 'Sign in by google or enter your credentials',
    googleLoginDino: 'Login with Google', */
    linkedInLogin: "Login with LinkedIn",
    facebookLogin: "Login with Facebook",
    dontHaveAnAccount: "Don't have an account?",
    alreadyHaveAnAccount: "Already have an account?",
    startNow: "START NOW",
    goToLogin: "GO TO LOGIN",
    emailConfirmation1: "Almost ready! We've sent a confirmation e-mail.",
    emailConfirmation2: "Just click on the link we've sent you to validate it.",
    continue: "Continue to Rubk:",
  },
  menu: {
    development: "My Projects",
    templates: "Templates",
    rateLibrary: "Rate Libraries",
    learning: "Learning and Support",
    account: {
      view: "View profile",
      leave: "Leave",
    },
  },
  updateCompositions: {
    loading: "Loading",
    details: "Details",
    status: "Status",
    code: "Code",
    alternativeCode: "Alternative code",
    resourceGroup: "Resource group",
    description: "Description",
    unity: "Unity",
    price: "Cost ($)",
    quantity: "Qty.",
    unitCost: "Unit Cost ($)",
    newCost: "New Cost ($)",
    totalCost: "Total Cost ($)",
    newComposition: "New composition",
    currentComposition: "Current composition",
    emptyComposition: "Empty composition",
    return: "Return",
    checkingProject: "Checking project compositions",
    updatingProject: "Updating project compositions",
    changeDescription: "Override composition descriptions in the EAP",
  },
  noresults: {
    ratelibrary: "rate library",
    library: "library",
    project: "project",
    noexisting: "No existing ",
    message: ", shall we begin?",
    createnew: "Create a new ",
    click: " by clicking the + button at the top",
  },
  developments: {
    templates: "Templates",
    compositionsDatabase: "Compositions Database",
    suportAndLearning: "Suport & Learning",
    developmentNotSelected: "Development don´t selected.",
    shareDevelopment: "Share Development",
    developmentSharedWithMe: "Development shared with me",
    view: "VIEW PROJECT",
    name: "Project Name",
    loading: "Loading projects",
    loadingUpdateWbs:
      "Please wait... We are optimizing your project performance...",
    removeAccess: "Remove access",
    removeAccessAlert: {
      title: "Remove shared project?",
      content:
        "This project will be removed from your access, only the author of the project will be able to share it again with your access.",
      confirm: "Remove my access",
    },
    header: {
      all: "All",
      favorites: "Favorites",
      search: "Search projects",
    },
    delete: {
      title: "Confirm delete?",
      content:
        "This project will be permanently deleted and will be unavailable to members who share it. This action can not be undone.",
      confirm: "Delete forever",
    },
    layerAdd: {
      new: "New Project",
      edit: "Edit address",
      title: "CREATE A NEW PROJECT",
      editAdrress: "EDIT PROJECT ADDRESS",
      placeholder: "Add a name for the project",
      placeholderAddress: "Project address",
      start: "Start",
      save: "Save",
      addTitle: "Add new project",
      useExisting: "Use Existing Project",
      createBlank: "Create blank",
      chooseProject: "Choose a project",
      noProjects: "You do not have any projects.",
      creatingProject: "Creating project...",
    },
    noUsersFound: {
      title: "No registered users.",
    },
    noResultsFound: {
      title: "No results found",
      subtitle: "Try adjusting your search to find what you are looking for.",
    },
    form: {
      title: "Development",
      name: "Name",
      image: "Image",
      favorite: "Favorite",
    },
    exceptions: {
      filetobig500k: "File is too big. Available size less then 500k.",
      favoriteException: "Erro ao marcar o projeto como favorito.",
    },
  },
  rateLibraries: {
    view: "OPEN RATE LIBRARY",
    name: "Rate Library Name",
    editLocation: "Edit location",
    shareLibraries: "Share rate library",
    browser: "Browser",
    resources: "Resources",
    RateLibrarySharedWithMe: "Rate Library shared with me",
    loading: "Loading rate library",
    tasks: "Tasks",
    layerAdd: {
      new: "New Rate Library",
      title: "CREATE NEW RATE LIBRARY",
      namePlaceholder: "Add a name to the rate library",
      descriptionPlaceholder: "Add a description (optional)",
      locationPlaceholder: "Add locations",
      sharePlaceholder: "Add e-mail address ",
      addTitle: "Add new rate library",
      importSpreadsheet: "Import Existing...",
      spreadsheetExemple: "Download here a sample worksheet",
      spreadsheetTutorial: "Learn more how to import libraries",
      fileType: "Accepted file type: Excel",
      soon: "SOON",
      createBlank: "Create blank",
      supportFileType: "File type not supported, only xls and xlsx",
    },
    dashHeader: {
      mine: "My Rate Libraries",
      public: "Public Rate Libraries",
      search: "Search",
    },
    delete: {
      title: "Confirm delete?",
      content:
        "This rate library will be permanently deleted and will be unavailable to members who share it. This action can not be undone.",
      confirm: "Delete forever",
    },
    error: {
      message: "ERROR",
      title: "Error processing data",
      tryAgain: "TRY AGAIN",
      multipleTabs: "The imported spreadsheet has more than one tab.",
      cancel: "CANCEL",
      emailNotFound: "E-mail not found",
      emailsOwner: "It is not possible to share with yourself",
      emailAlreadyAdded: "E-mail already added",
    },
    card: {
      import: "Import worksheet...",
    },
    cardProcessing: {
      by: "By",
      waiting: "Waiting to process",
      importing: "Importing",
      processing: "Processing",
      errorMessage:
        "An error ocurred including the rate library's information. Review provided information and file and try again.",
    },
    header: {
      code: "Code",
      description: "Description",
      unity: "Unity",
      alternativeCode: "Alternative Code",
      price: "Cost ($)",
      quantity: "Qty.",
      unitCost: "Unit Cost ($)",
      totalCost: "Total Cost",
    },
  },
  contributors: {
    addContributors: "Add Contributors",
  },
  profile: {
    name: "Name",
    email: "E-Mail",
    password: "Change Password",
    registerPassword: "Register Login/Password",
    options: {
      file: "select file",
      facebook: "import from facebook",
      google: "import from google",
    },
    tab: {
      myProfile: "My Profile",
      company: "Company",
      contributors: "Contributors",
    },
    contributors: {
      loading: "Loading users",
      access: "Access",
      name: "Name",
      actived: "Actived",
      active: "Active",
      inactive: "Inactive",
      inactivated: "Inactivated",
      delete: "Delete",
      administrator: "Administrator",
      operator: "Operator",
      createContributor: "Create Contributor",
    },
    emailVerification: {
      notVerified: "Unverified Email",
      sendAgain: "Send verification again",
    },
    link: {
      google: "Linked to Google",
      facebook: "Linked to Facebook",
    },
    modalLinkCredencial: {
      title: "Register login and password",
    },
    settings: "See profile settings",
  },
  company: {
    companyName: "Company Name",
    placeholder: "Add the company name",
    companyLogo: "Company Logo",
    chooseFile: "Choose a file",
    changeImage: "Change Image",
    saveCompany: "Your company information has been updated successfully",
    removeLogo: "Your company logo has been successfully removed",
  },
  library: {
    title: "LIBRARY",
    active: "Active",
    upload: "Upload",
    send: "send",
    uploadFile: "Carregar Arquivo",
    // onlyTypeDialogFile: "Only types like ifc and ifczip.",
    onlyTypeDialogFile: "Only types like ifc.",
    chooseFile: "Choose a file.",
    enabled: "Enabled",
    disabled: "Disabled",
    tabTitle: "Navigator",
    tabTitle3D: "3D Navigator",
    status: {
      pending: "Pending",
      processing: "Processing",
      completed: "Processed",
      error: "Error",
    },
    empty: {
      title: "The Library is empty.",
      subtitle1: "Click to Upload button to",
      subtitle2: "uploads IFC files.",
    },
    loading: {
      title: "Loading files...",
      subtitle1: "Wait a moment, please.",
    },
    message: {
      IFCNotSelected: "IFC is not selected.",
      cancelUpload: "Upload canceled",
      errorUpload: "There was an error uploading your file, please try again.",
      // errorUploadFormat:
      //   "Please upload file having extensions .IFC/.IFCZIP only.",
      errorUploadFormat: "Please upload file having extensions .IFC only.",
      errorNotXeokitProject:
        "To use the updated model viewer it is necessary to delete and add your files again, or use the option to “Create new from this one” in your list of registered projects and import the necessary models",
      errorImageFormat:
        "Please upload file having extensions .jpg|.gif|.png only.",
      errorEnableFile: "Error enabling / disabling file.",
      errorEnableRenderFile: "Error enabling / disabling file rendering.",
      errorChangeStatus: "Error while changing file status.",
      errorDeleteFile1:
        "File can not be deleted, there is ModelMaps using this File: ",
      erroADeleteFile2: "Delete them manually and try deleting the file again.",
      active3D: "3D Model activated for this cost plan.",
      disactive3D: "3D Model deactivated for this cost plan",
      noIFCforRender: "There aren't any 3D models to render.",
      noIFCforRenderSub:
        "Send and/or activate a 3D Model on the Library panel to render",
      duplicateIFC: "File/IFC already existing",
    },
    delete: {
      title: "Confirm delete?",
      content:
        "This .ifc file will be permanently deleted. This action can not be undone.",
      confirm: "Delete forever",
    },
  },
  costplan: {
    costPlanTitle: "Cost plans",
    createNew: "Create new",
    export: {
      titleprocessing: "Generating file, please wait...",
      titleprocessed: "File generated.",
      processing: "Processing...",
      download: "Download",
    },
    duplicateCostPlan: "Duplicate cost plan",
    costPlanName: "Nome do plano de custo",
    newCostPlanNameBlank: "Cost plan name",
    costPlanDescription: "Cost plan description (optional)",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    alertDeleteCostPlan:
      "This process will delete the cost plan and all of its contents.",
    unavailableAction: "Unavailable action",
    warningOneCostPlan: "You must have at least one cost plan in the project.",
    acceptWarning: "I understood",
    nameWbsAlreadyExists: "A cost plan with that name already exists",
  },

  project: {
    leftSideMenu: {
      navigator: "Navigator",
      library: "Library",
      costPlan: "Cost plan",
      viewer: "Viewer 3D",
    },
    rightSideMenu: {
      properties: "PROPERTIES",
      code: "Code",
      formula: "Quantity Formula",
      type: "Type",
      origin: "Cost Origin",
      costOrigin: {
        database: "Database",
        scope: "Scope",
        additionalInformation: "Additional information",
        composition: "Composition",
        resource: "Resource",
      },
      occurencesInBudget: "Occurrences in the budget",
      viewOccurrences: "View Occurrences",
      viewer3d: "Viewer 3D",
      takeOffDescription: "Take Off Description",
      takeOffPath: "Quantity Link",
      takeOffPathNotFound: "Model Map not found",
      takeOffRemoveSource: "Remove Quantity Link",
      composition: "Costs composition",
      categories: {
        labor: "Labor",
        material: "Material",
        equipment: "Equipment",
        task: "Task",
        other: "Other",
        1: "Labor",
        2: "Material",
        3: "Equipment",
        4: "Task",
        5: "Other",
      },
      stage: {
        title: "No properties",
        subtitle:
          "This element does not contain additional information to display.",
      },
      wbs: {
        title: "Decimal Places",
        unitCost: "Unit Cost",
        roundingRule: {
          title: "Rounding Rule",
          round: "Round",
          trunc: "Trunc",
          eapTab: "EAP",
          insumoTab: "INSUMOS",
        },
        recalculate: "Recalculate",
      },
      thisWBS: "This cost plan",
      WBSInfo: {
        monthBase: "Base Month",
        monthRelease: "Term of Work",
        monthReleaseFocus: "Term of Work (month)",
        landArea: "Land Area",
        landAreaFocus: "Land Area (m²)",
        privateUnits: "Private Units",
        privateUnitsFocus: "Private Units (un)",
        builtArea: "Built Area",
        builtAreaFocus: "Built Area (m²)",
        equivalentArea: "Equivalent Area",
        equivalentAreaFocus: "Equivalent Area (m²)",
        privateArea: "Private Area",
        privateAreaFocus: "Private Area (m²)",
        messageMonth: "Enter numbers only",
        messageInput: "Enter numbers and separators only (. or ,)",
      },
      bdi: {
        title: "Sale price",
        showInEap: "View BDI in EAP",
        percentual: "BDI (%)",
      },
      customProperties: {
        title: "Custom Properties",
        editProperties: "Edit Properties",
        addProperty: "Add Property",
        deleteModal: {
          title: "Delete property?",
          text: "This process will delete the selected property and its contents on all lines.",
          buttonConfirm: "Delete forever",
        },
      },
    },
    table: {
      newResource: "Untitled Resource",
    },
    searchField: {
      resources: "Resources",
      tasks: "Compositions",
      line: "Line",
      placeholder: "Enter a term to search",
    },
  },
  syntheticReport: {
    reportTitle1: "RUBK ",
    reportTitle2: " REPORT",
    address: "Address",
    baseMonth: "Base Month",
    monthRelease: "Project Term",
    areaCost: "COST PER AREA ($/m²)",
    totalCost: "TOTAL COST ($)",
    landArea: "Land Area (m²)",
    privateUnits: "Private Units",
    builtArea: "Built Area (m²)",
    equivalentArea: "Equivalent Area (m²)",
    privateArea: "Private Area (m²)",
    structuredCode: "Structured Code",
    font: "Source",
    code: "Code",
    description: "Description",
    quantity: "Coefficient",
    serviceQuantity: "Quantity",
    priceLabor: "Labor Cost",
    priceMat: "Mat Cost",
    priceOther: "Other Cost",
    unity: "unity",
    serviceCost: "Unity Cost",
    total: "Total Cost",
    totalBdi: "Total Bdi",
    precoVenda: "Sale Price",
    precoTotal: "Total Price",
    bdiPercent: "BDI (%)",
    budgetAnalytical: "Analytical ",
    budgetSynthetic: "Synthetic ",
    budget: "Budget",
    resources: "Resources",
    takeoff: "Take Off Itens",
    formating: "Formating",
    curveABC: "Services",
  },
  icons: {
    cut: "Cut",
    copy: "Copy",
    replicate: "Replicate",
    paste: "Paste",
    insertRowBelow: "Insert row below",
    insertRowAbove: "Insert row above",
    formula: "Formula",
    delete: "Delete",
    separate: "Split itens",
    agroup: "Group itens",
    moveup: "Move up",
    movedown: "Move down",
    undo: "Undo",
    search: "Search",
  },
  modelMaps: {
    modalExcludeFormula: {
      title: "Delete formula and replace quantity?",
      text_01: "We identified a quantity formula in this line, when selecting",
      text_02: " replace,",
      text_03: " the formula will be deleted and the value will be replaced",
      cancel: "Cancel",
      exclude: "Delete and Replace",
    },
    menuLateral: {
      modelMaps: "3D BIM MODEL MAPS",
      add: "Add to cost plan",
      duplicate: "Duplicate Model Map",
      quantities: "QUANTITIES",
      copy: " - Copy",
      newModel: "new model",
      noModels: "No Model Map available.",
      noModelsSubtitle: "Click on NEW MODEL to create a new Model Map",
      noModelSearch: "No results found.",
      noModelSearchSubtitle:
        "Try adjusting your search to find what you are looking for.",
      noFormatDefined: "This Model Map doesn’t have a format defined.",
      noFormatDefined2: "Edit it before adding to the cost plan.",
      category: "Category",
      model3d: "3D Model",
      filter: "Filter",
      properties: "Properties",
      libraryUpdated: "3D model available on the project library were updated.",
      libraryUpdated2: "Check the changes needed on your Model Maps.",
      noModel3d: "Please include a 3D model in the library",
      noModel3d2error: "to make the necessary corrections in the model map.",
      noModel3d2: "to edit the model map.",
    },
    addLayer: {
      noFileToAddLayer: "There is no active 3D model in this WBS.",
      enableFileToAddLayer:
        "Access the library panel, import and/or activate a model on this WBS to create a new Model Map.",
      modelName: "Add a name to the Model Map",
      models: "3D MODELS",
      modelsFiltered: "FILTERED 3D MODELS",
      useAllModels: "USE ALL 3D MODELS",
      filterModels: "FILTER 3D MODELS",
      modelIFC: "Select one or more 3D models",
      modelCategories: "Select or type categories",
      allModels: "Todos modelos 3D aplicados a esse model map",
      headerECView: "MODEL MAP OF BUILDING ELEMENTS",
      headerEC: "CREATE A NEW MODEL MAP OF BUILDING ELEMENTS",
      headerMatView: "MODEL MAP OF MATERIALS",
      headerMat: "CREATE A NEW MODEL MAP OF MATERIALS",
      constructiveElements: "Constructive Elements",
      Materials: "Materials",
    },
    takeOffLayer: {
      description: "Description",
      quantity: "Quantity",
      unit: "Unit",
      formulaWithNoQuantity:
        "The formula provided did not generated any quantities",
      saveFormat: "Apply Take Off format",
      editFormat: "Edit Take Off format",
      errorSelect: "There are errors that need to be corrected!",
      addField: "ADD FIELD",
      searchField: "Search for field",
    },
    description: {
      buildingElements: "Building Elements",
    },
    filter: {
      operators: {
        and: "and",
        or: "or",
      },
      operations: {
        equal: "Equals",
        lessThan: "Less than",
        greaterThan: "Greater than",
        contains: "Contains",
        notcontains: "Does not contain",
        blank: "Blank",
        filled: "Filled",
      },
    },
    delete: {
      title: "Confirm deletion?",
      content: "The quantities added to the project will be kept.",
    },
    removeLink: {
      title: "Remove quantity link?",
      content1: "This cost plan item is linked to the model map: ",
      content2:
        ". After removing this link the quantity will remain but will not be changed in updates of this model map.",
    },
  },
  resources: {
    description: "Description",
    quantity: "Quantity",
    unity: "Unity",
    unitCost: "Unit Cost. ($)",
    newCost: "New Cost. ($)",
    total: "Total ($)",
    classification: "Classification",
    origin: "Origin",
    percentage: "Percentage",
    cumulativePercentage: "Cumulative Percentage",
    cumulativePercentageSmall: "% Cumul.",
  },
  wbs: {
    calculating: {
      title: "Recalculating Values",
      subtitle: "Please wait",
      tooltip: "Click to perform the recalculation.",
      modal: {
        title: "Recalculate the cost plan?",
        subtitle:
          "You need to recalculate this cost plan as there are changes that affect totals. Depending on the volume of data in the cost plan, this recalculation may take several minutes.",
      },
    },
    error: {
      columnNotFound: "Column not found: ",
      updateBudgetResources:
        "An error occurred while updating budget resources!",
    },
    itemOccurrences: {
      title: "Occurrences of the item in the EAP",
      loadingMessage: "Loading preview of occurrences...",
      equipment: "Equipment",
      labor: "Labor",
      material: "Material",
      others: "Others",
      return: "Return",
      fields: {
        code: "EAP Code",
        description: "Description",
        quantity: "Quantity",
        unit: "Unit",
        costUnit: "Unit cost",
        total: "Total",
        totalUnit: "Total Unit",
        percentual: "%",
      },
    },
    newProperty: "New Property",
    selectFile: "Select a file to import",
    importFile: "Import file...",
    name: "Name",
    column: "Column",
    continue: "Continue",
    import: "Import",
    structCode: "Structural Code",
    alternative: "Code",
    description: "Description",
    resourceCode: "Resource Code",
    resourceQuantity: "Resource Quantity",
    resourceCost: "Resource Cost",
    resourceCoefficient: "Resource Coefficient",
    serviceQuantity: "Quantity",
    serviceCost: "Service Cost",
    unitCost: "Unit Cost",
    unit: "Unit",
    total: "Total",
    associateColumn: "ASSOCIATE FILE COLUMNS WITH BUDGET COLUMNS",
    createProperties: "CREATE CUSTOM PROPERTIES FOR YOUR BUDGET",
    loading: "Loading cost plan...",
    preparing: "Preparing...",
    processing: "Processing",
    principal: "Principal",
    blank: "Blank",
    fromSpreadsheet: "Import from a spreadsheet",
    createCopy: "Create a copy from the current one",
    overlapData: "Overlay existing data?",
    exportxlsx: "Export WBS to Excel (Standard Mega)",
    exportByGroupxlsx: "Export resources by group report to Excel",
    exportSyntheticxlsx: "Export synthetic report to Excel",
    exportCurveABC: "Export Services ABC Curve to Excel",
    exportCurveABCAnalytical:
      "Export ABC Curve from Analytical Services to Excel",
    exportAnalyticalxlsx: "Export analytical report to Excel",
    nameReportCurveABC: "ABC curve of services",
    nameReportCurveABCAnalytical: "ABC curve of analytical services",
    totalCostReportCurveABC: "Total cost of services",
    exportSAPSheet: "Export SAP spreadsheet",
    exportTakeOffxlsx: "Export model map take off list to Excel",
    exportFormatxlsx: "Export model map format to Excel",
    exportResourcexlsx: "Export resources to Excel",
    isolateInCP: "Highlight elements used in the cost plan",
    isolateNotInCP: "Highlight elements not used in the cost plan",
    noRowsToExport: "No data to export",
    updateBudgetResources: "Update budget resources",
    updateCompositions: "Update compositions",
    newRateLibraries: "Select the rate library",
    noNewValues: "No resources from this rate libraries were found in the EAP",
    importSettings: "Import settings",
    totalcost: "Total Cost",
    totalsales: "Total Sales",
  },
  viewer: {
    isolateFromTakeOff: { isolate: "Highlight", items: "items" },
    noFilesToRenderItems:
      "Send and/or activate the 3D Model with this items on the Library panel to render.",
    clickEvent: "Click Event",
    isolateElement: "Highlight Elements",
    toolbar: {
      restore: "Restore",
      similar: "Select Alike",
      isolate: "Isolate Selection",
      highlight: "Highlight Selection",
      makeVisible: "Make Visible",
      makeUnvisible: "Make Unvisible",
      fade: "Normal/Fade",
      cut: "Cut",
      search: "Search",
      panMode: "Pan Mode",
      ruler: "Ruler",
    },
    properties: {
      multipleSelection: " selected elements",
      singleSelection: " selected element",
      noProperties: "No properties.",
      noInfos1: "No aditional data",
      noInfos2: "to show",
    },
    action: {
      label: "Action",
      hide: "Hide",
      paint: "Paint",
      glass: "Glass",
      original: "Original",
      info: "Infos",
    },
    agroup: {
      label: "Group By",
      element: "Element",
      type: "Type",
    },
    apply: {
      label: "Apply",
      selected: "On Selected",
      remaining: "For Remainder",
    },
    clip: {
      label: "Clip",
      action: "Action",
      reset: "Reset",
    },
    reset: {
      label: "Make all",
      style: "Default",
      hide: "Visible",
    },
    view: {
      label: "View",
      normal: "Normal",
      xray: "X-Ray",
    },
    elements: {
      label: "Elements",
      filter: {
        label: "Filter",
        type: "Type",
        guid: "GUID",
      },
    },
    message: {
      errorWBSEmpty:
        "Cost plan does not exist. Create the cost plan in [menu / planocusto] in order to use this feature.",
    },
    navigator: {
      title: "NAVIGATOR",
      empty: {
        title: "No 3D model selected",
        subtitle1: "Enable a 3D model",
        subtitle2: "on the Library tab.",
      },
      loading: {
        title: "Loading 3D models...",
        subtitle1: "Wait a moment, please.",
      },
    },
  },
  date: {
    ago: "ago",
    today: "today",
    day: "day",
    days: "days",
    week: "week",
    weeks: "weeks",
    month: "month",
    months: "months",
    year: "year",
    years: "years",
  },
  firebaseFunctions: {
    sendPasswordResetEmail: {
      "auth/too-many-requests":
        "We have blocked all requests from this device due to unusual activity. Try again later.",
      error: "Error sending email, please try again later",
    },
    linkWithPopup: {
      success: "Account linked successfully.",
      "auth/credential-already-in-use":
        "This credential is already associated with a different user account.",
      "auth/provider-already-linked":
        "User can only be linked to one identity for the given provider.",
      "auth/email-already-in-use":
        "The email address is already in use by another account.",
      error: "Error linking your account, please try again later",
    },
    unlink: {
      success: "Account unlinked successfully.",
      error: "Error unlinking your account, please try again later.",
    },
    updateEmail: {
      success: "Your email has been successfully edited.",
      "auth/requires-recent-login":
        "This operation is sensitive and requires recent authentication. Please log in again before attempting to edit this user's email address",
      error: "Error editing email from your account, please try again later.",
    },
    updateProfile: {
      success: "The user profile has been edited successfully.",
      error: "Error editing profile, please try again later.",
    },
    linkWithCredential: {
      success: "Your email has been successfully linked.",
      "auth/requires-recent-login":
        "This operation is sensitive and requires recent authentication. Please sign in again before attempting to link the email to this user.",
      error: "Error linking email to your account, please try again later.",
    },
    sendEmailVerification: {
      success: "The verification email was sent successfully.",
      error: "Error sending verification email, please try again later.",
    },
  },
  ifc: {
    // O campo deve ter o mesmo nome do IFC no projeto
    IfcAirTerminal: "Air terminal",
    IfcAlarmType: "Alarm type",
    IfcAnnotation: "Annotation",
    IfcAssembly: "Assembly",
    IfcBuildingElementPart: "Building element part",
    IfcBuildingElementProxy: "Building element proxy",
    IfcBuildingStorey: "Building storey",
    IfcCableCarrierFitting: "Cable carrier fitting",
    IfcCableCarrierFittingType: "Cable carrier fitting type",
    IfcCableCarrierSegment: "Cable carrier segment",
    IfcColumn: "Column",
    IfcCovering: "Covering",
    IfcCurtainWall: "Curtain wall",
    IfcDoor: "Door",
    IfcDuctFitting: "Duct fitting",
    IfcDuctSegment: "Duct segment",
    IfcElectricApplianceType: "Electric appliance type",
    IfcElementAssembly: "Element assembly",
    IfcFireSuppressionTerminalType: "Fire suppression terminal type",
    IfcFlowTerminal: "Flow terminal",
    IfcFurniture: "Furniture",
    IfcGroup: "Group",
    IfcLightFixtureType: "Light fixture type",
    IfcMechanicalFastener: "Mechanical fastener",
    IfcOpening: "Opening",
    IfcOpeningElement: "Opening element",
    IfcPipeFitting: "Pipe fitting",
    IfcPipeSegment: "Pipe segment",
    IfcPlate: "Plate",
    IfcRailing: "Railing",
    IfcRamp: "Ramp",
    IfcReinforcementMesh: "Reinforcement mesh",
    IfcReinforcingBar: "Reinforcing bar",
    IfcReinforcingMesh: "Reinforcing mesh",
    IfcRoof: "Roof",
    IfcSite: "Site",
    IfcSlab: "Slab",
    IfcSpace: "Space",
    IfcStair: "Stair",
    IfcSwitchingDeviceType: "Switching device type",
    IfcSystemFurnitureElement: "System furniture element",
    IfcValveType: "Valve type",
    IfcWall: "Wall",
    IfcWindow: "Window",
    IfcZone: "Zone",
  },
  exportByGroup: {
    title: "Export resources by group",
    syntheticExport: "Synthetic export",
    analyticalExport: "Analytical export",
    chooseProperty: "Choose which property you want to group your report on.",
    selctLineText: "Selected lines for replication",
    inputPlaceholder: "Search Line",
    notResultBox: {
      noResultes: "No results at the moment.",
      trySearching: "Try searching for some EAP task.",
    },
  },
  replicate: {
    title: "Replicate Information",
    selctLineText: "Selected lines for replication",
    inputPlaceholder: "Search Line",
    notResultBox: {
      noResultes: "No results at the moment.",
      trySearching: "Try searching for some EAP task.",
    },
  },
  unlinkCompositionDialog: {
    title: "Remove link?",
    body: `When confirming this operation, the selected line will no longer have a link with other EAP lines,
     subsequent changes in its information will no longer be replicated to the other previously linked lines. 
     Do you wish to continue?`,
    cancel: "Cancel",
    confirm: "Remove Link",
  },
};



// WEBPACK FOOTER //
// ./src/locales/en-US.ts